// eslint-disable-next-line import/no-extraneous-dependencies
import ReactGA from 'react-ga4';

export const eventName = 'BookViewingClick';
export const eventCategory = 'Application';
export const eventAction = 'Click';
export const eventLabel = 'Clicked book viewing link';

export default (eventArgs = {}) =>
  ReactGA.event(eventName, {
    category: eventCategory,
    action: eventAction,
    label: eventLabel,
    transport: 'xhr',
    ...eventArgs,
  });
